<template>
  <div>
    <popup-add-product
      v-if="stockingTemplate"
      ref="popupAddMandatoryProduct"
      @productSelected="mandatoryProductSelected"
      :existingProducts="productsCombined"
      :totalVenueStock="stockProducts"
    />
    <popup-add-product
      v-if="stockingTemplate"
      ref="popupAddOptionalProduct"
      @productSelected="optionalProductSelected"
      :existingProducts="productsCombined"
      :totalVenueStock="stockProducts"
    />

    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      max-items="100"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isActive"
    >
      <div
        class="mt-6 flex items-center justify-between px-6"
        v-if="stockingTemplate"
      >
        <div class="flex items-center">
          <img
            v-if="stockingTemplate.imageUrl && stockingTemplate.imageUrl !== ''"
            width="40"
            :src="stockingTemplate.imageUrl"
            class="mr-4"
          />
          <img v-else width="40" :src="ProductIcon" class="mr-4" />
          <div>
            <h4>Stocking Template</h4>
            <small v-if="stockingTemplate.name">{{
              stockingTemplate.name
            }}</small>
          </div>
        </div>
        <feather-icon
          icon="XIcon"
          @click.stop="isActive = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <Loading v-if="isLoading" />
        <div v-else class="p-6">
          <div class="flex flex-col mb-3" v-if="!isNew">
            <div class="mb-1 text-sm">
              <span>Created by</span>
            </div>
            <div>
              <code
                >{{ orgStockingTemplate.createdBy.username }} at
                {{ orgStockingTemplate.createdAt | formatDate }}</code
              >
            </div>
          </div>

          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Template name</span>
            </div>
            <div>
              <vs-input class="w-full" v-model="stockingTemplate.name" />
            </div>
          </div>

          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Image url</span>
            </div>
            <div>
              <vs-input class="w-full" v-model="stockingTemplate.imageUrl" />
            </div>
          </div>

          <vs-divider />
          <p class="mb-3" style="font-weight: bold">Stock products</p>

          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Mandatory products</span>
            </div>
            <div>
              <vs-table
                :data="filteredMandatoryProducts"
                style="margin-left: -24px; margin-right: -24px"
                noDataText=""
              >
                <!--     <template slot="header">
                  <h3 class="ml-6 mb-1">Products</h3>
                </template> -->
                <template slot="thead">
                  <!--                   <vs-th sort-key="namne"> Number </vs-th> -->
                  <vs-th sort-key="amount"> Name </vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                    <!--                <vs-td>
                      <div>{{ tr.name }}</div>
                      <div>
                        <small class="text-grey">{{
                          tr.stockProductId.id
                        }}</small>
                      </div>
                    </vs-td> -->

                    <vs-td>
                      <span class="text-muted"> {{ tr.name }}</span>
                    </vs-td>

                    <vs-td>
                      <feather-icon
                        @click="removeMandatoryProduct(tr.stockProductId.id)"
                        icon="TrashIcon"
                        class="cursor-pointer mr-2"
                        svgClasses="h-5 w-5 stroke-2"
                      />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <!-- <p v-for="id in stocktake.stockProductIds" :key="id">{{ id }}</p> -->
              <div class="flex justify-center mt-2">
                <vs-button
                  class="ml-2 py-2 px-3 rounded"
                  @click="$refs.popupAddMandatoryProduct.show()"
                >
                  Add product
                </vs-button>
              </div>
            </div>
          </div>

          <!-- Optional -->
          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Optional products</span>
            </div>
            <div>
              <vs-table
                :data="filteredOptionalProducts"
                style="margin-left: -24px; margin-right: -24px"
                noDataText=""
              >
                <!--     <template slot="header">
                  <h3 class="ml-6 mb-1">Products</h3>
                </template> -->
                <template slot="thead">
                  <!--                   <vs-th sort-key="namne"> Number </vs-th> -->
                  <vs-th sort-key="amount"> Name </vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                    <!--                <vs-td>
                      <div>{{ tr.name }}</div>
                      <div>
                        <small class="text-grey">{{
                          tr.stockProductId.id
                        }}</small>
                      </div>
                    </vs-td> -->

                    <vs-td>
                      <span class="text-muted"> {{ tr.name }}</span>
                    </vs-td>

                    <vs-td>
                      <feather-icon
                        @click="removeOptionalProduct(tr.stockProductId.id)"
                        icon="TrashIcon"
                        class="cursor-pointer mr-2"
                        svgClasses="h-5 w-5 stroke-2"
                      />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <!-- <p v-for="id in stocktake.stockProductIds" :key="id">{{ id }}</p> -->
              <div class="flex justify-center mt-2">
                <vs-button
                  class="ml-2 py-2 px-3 rounded"
                  @click="$refs.popupAddOptionalProduct.show()"
                >
                  Add product
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button
          class="mr-6"
          @click="create"
          :disabled="!isFormValid"
          v-if="isNew"
        >
          Create
        </vs-button>
        <vs-button
          class="mr-6"
          @click="save"
          :disabled="!isFormValid"
          v-if="!isNew"
        >
          Save
        </vs-button>
        <vs-button v-if="!isNew" color="danger" @click="confirmDelete">
          Delete</vs-button
        >
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ProductIcon from "@/assets/images/shout-icon.png";
import { mapGetters } from "vuex";
import PopupAddProduct from "./PopupAddProduct.vue";

export default {
  components: {
    VuePerfectScrollbar,
    PopupAddProduct,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      ProductIcon,

      isActive: false,
      isLoading: true,

      isNew: false,
      stockingTemplate: null,
      orgStockingTemplate: null,
    };
  },
  computed: {
    ...mapGetters({
      stockProducts: "stockProducts/stockProducts",
    }),
    productsCombined() {
      return [
        ...this.stockingTemplate.mandatoryStockProductIds,
        ...this.stockingTemplate.optionalStockProductIds,
      ];
    },
    filteredMandatoryProducts() {
      return this.stockProducts.filter((x) =>
        this.stockingTemplate.mandatoryStockProductIds.includes(
          x.stockProductId.id
        )
      );
    },

    filteredOptionalProducts() {
      return this.stockProducts.filter((x) =>
        this.stockingTemplate.optionalStockProductIds.includes(
          x.stockProductId.id
        )
      );
    },
    isFormValid() {
      return true;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    removeOptionalProduct(id) {
      this.stockingTemplate.optionalStockProductIds =
        this.stockingTemplate.optionalStockProductIds.filter((x) => x !== id);
    },
    optionalProductSelected(productId) {
      console.log("Adding", productId);
      this.stockingTemplate.optionalStockProductIds.push(productId);
    },
    removeMandatoryProduct(id) {
      this.stockingTemplate.mandatoryStockProductIds =
        this.stockingTemplate.mandatoryStockProductIds.filter((x) => x !== id);
    },
    mandatoryProductSelected(productId) {
      console.log("Adding", productId);
      this.stockingTemplate.mandatoryStockProductIds.push(productId);
    },
    async showEmpty() {
      this.isActive = true;
      this.isLoading = true;
      this.isNew = true;

      this.orgStockingTemplate = null;

      this.stockingTemplate = {
        name: "",
        mandatoryStockProductIds: [],
        optionalStockProductIds: [],
        imageUrl: "",
      };

      await this.loadExternalData();
      this.isLoading = false;
    },
    async show(stockingTemplateId) {
      this.isActive = true;
      this.isLoading = true;
      this.isNew = false;

      var result = await this.$store.dispatch(
        "stockingTemplates/getStockingTemplate",
        stockingTemplateId
      );

      this.orgStockingTemplate = result;
      this.stockingTemplate = {
        name: result.name,
        mandatoryStockProductIds: result.mandatoryStockProducts.map(
          (e) => e.stockProductId.id
        ),
        optionalStockProductIds: result.optionalStockProducts.map(
          (e) => e.stockProductId.id
        ),
        imageUrl: result.imageUrl,
      };

      await this.loadExternalData();
      console.log("Got stocking template", this.stockingTemplate);
      this.isLoading = false;
    },
    async loadExternalData() {
      await this.$store.dispatch("stockProducts/getStockProducts", {
        take: 100000,
        skip: 0,
      });
    },
    confirmDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Delete this stocking template?`,
        accept: this.deleteSchema,
      });
    },
    async deleteSchema() {
      await this.$store.dispatch(
        "stockingTemplates/deleteStockingTemplate",
        this.orgStockingTemplate.id
      );

      this.$vs.notify({
        title: "Template deleted",
        text: "Your template has been deleted.",
      });

      this.isActive = false;
      this.isLoading = true;
    },
    async save() {
      console.log("Saving DTO", this.stockingTemplate);

      this.stockingTemplate.id = this.orgStockingTemplate.id;

      const result = await this.$store.dispatch(
        "stockingTemplates/updateStockingTemplate",
        {
          id: this.orgStockingTemplate.id,
          dto: this.stockingTemplate,
        }
      );

      // await new Promise((resolve) => setTimeout(resolve, 1500)); // FIXME - Wait for backend to update

      this.$vs.notify({
        title: "Template saved",
        text: "Your template has been saved.",
      });

      this.isActive = false;
      this.isLoading = true;
    },
    async create() {
      console.log("Creating DTO", this.stockingTemplate);

      const result = await this.$store.dispatch(
        "stockingTemplates/createStockingTemplate",
        this.stockingTemplate
      );

      //await new Promise((resolve) => setTimeout(resolve, 1500)); // FIXME - Wait for backend to update

      this.$vs.notify({
        title: "Template created",
        text: "Your template has been created.",
      });

      this.isActive = false;
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>